// extracted by mini-css-extract-plugin
export default {"container":"Sca-z","oos":"Tca-z","oosUx":"Uca-z","selected":"Vca-z","labelOos":"Wca-z"};